import { ReactNode,useState } from 'react';

import { DataModelAttribute } from '@/types/DataModel';

import { FocusAttributeContext } from './FocusAttributeContext';

interface FocusAttributeProviderProps {
  children: ReactNode;
}

export const FocusAttributeProvider = ({ children }: FocusAttributeProviderProps) => {
    const [focusAttribute, setFocusAttribute] = useState<DataModelAttribute | undefined>(undefined);
    const [pinnedAttributeName, setPinnedAttributeName] = useState<string | undefined>(undefined);
    const [sectionOpen, setSectionOpen] = useState(false);

    return (
        <FocusAttributeContext.Provider value={{ focusAttribute, setFocusAttribute, pinnedAttributeName, setPinnedAttributeName, sectionOpen, setSectionOpen }}>
            {children}
        </FocusAttributeContext.Provider>
    );
};

